import { render } from "./Safety.vue?vue&type=template&id=97abdace&scoped=true"
import script from "./Safety.vue?vue&type=script&lang=js"
export * from "./Safety.vue?vue&type=script&lang=js"

import "./Safety.vue?vue&type=style&index=0&id=97abdace&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97abdace"]])

export default __exports__